// Purpose: admin routing dashboard + DLQ actions + circuit breaker control.

import { api, csrfHeaders } from './client.ts';
import type { RoutingCircuitBreakerSnapshot, RoutingSnapshot } from './admin-dashboard.ts';

export type { RoutingCircuitBreakerSnapshot, RoutingSnapshot };

export interface RoutingJob {
  jobId: string;
  uploadId: string;
  dropboxId: string;
  target: 'SHAREPOINT' | 'ONEDRIVE' | 'SHARED_DRIVE' | 'EPHEMERAL';
  retryCount: number;
  enqueuedAt: string;
}

export async function fetchRoutingSnapshot(): Promise<RoutingSnapshot> {
  const res = await api.get<RoutingSnapshot>('/admin/routing/snapshot');
  return res.data;
}

export async function fetchActiveJobs(): Promise<RoutingJob[]> {
  const res = await api.get<{ jobs: RoutingJob[] }>('/admin/routing/jobs/active');
  return res.data.jobs;
}

export async function fetchDeadLetter(): Promise<RoutingJob[]> {
  const res = await api.get<{ jobs: RoutingJob[] }>('/admin/routing/jobs/dead');
  return res.data.jobs;
}

export async function replayJob(jobId: string): Promise<{ newJobId: string }> {
  const res = await api.post<{ newJobId: string }>(`/admin/routing/jobs/${jobId}/replay`, null, {
    headers: csrfHeaders(),
  });
  return res.data;
}

export async function discardJob(jobId: string, reason: string): Promise<void> {
  await api.post(`/admin/routing/jobs/${jobId}/discard`, { reason }, { headers: csrfHeaders() });
}

export async function fetchCircuitBreakerState(): Promise<RoutingCircuitBreakerSnapshot> {
  const res = await api.get<RoutingCircuitBreakerSnapshot>('/admin/routing/circuit-breaker');
  return res.data;
}

export async function resetCircuitBreaker(): Promise<void> {
  await api.post('/admin/routing/circuit-breaker/reset', null, { headers: csrfHeaders() });
}
